/* Kopstorm buy box V2 — Rho Nutrition
   The script never writes prices or labels. Every state is rendered server side
   and revealed by CSS from data-mode / data-sub / data-otp, so a selection
   change is a single attribute write and cannot flash or mis-format money. */
(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-kop-bb2-bound') === 'true') return;
    root.setAttribute('data-kop-bb2-bound', 'true');

    var formId = root.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    var groups = {};

    Array.prototype.forEach.call(root.querySelectorAll('[data-kop-group]'), function (g) {
      groups[g.getAttribute('data-kop-group')] = g;
    });

    function variantSelect() {
      if (!form) return null;
      return form.querySelector('select[name="id"], input[name="id"]');
    }

    function planInput() {
      if (!form) return null;
      return form.querySelector('[name="selling_plan"]');
    }

    function mirrors() {
      var out = [];
      if (form) {
        Array.prototype.push.apply(out, form.querySelectorAll('[data-kop-atc]'));
      }
      Array.prototype.push.apply(out, document.querySelectorAll('[data-kop-atc][data-form="' + formId + '"]'));
      return out.filter(function (el, i, a) { return a.indexOf(el) === i; });
    }

    function optionsOf(mode) {
      var g = groups[mode];
      return g ? g.querySelectorAll('[data-kop-opt]') : [];
    }

    function selectedOption(mode) {
      var g = groups[mode];
      if (!g) return null;
      return g.querySelector('[data-kop-opt].is-selected') || g.querySelector('[data-kop-opt]');
    }

    function pushToForm(opt, notify) {
      if (!opt || !form) return;
      var vid = opt.getAttribute('data-variant-id') || '';
      var pid = opt.getAttribute('data-plan-id') || '';
      var sel = variantSelect();
      var plan = planInput();

      if (plan) plan.value = pid;

      if (sel && vid && sel.value !== vid) {
        sel.value = vid;
        if (notify) sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function apply(mode, opt, notify) {
      var g = groups[mode];
      if (!g || !opt) return;

      Array.prototype.forEach.call(optionsOf(mode), function (o) {
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        var radio = o.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      Object.keys(groups).forEach(function (key) {
        groups[key].classList.toggle('is-open', key === mode);
      });

      var vid = opt.getAttribute('data-variant-id') || '';
      root.setAttribute('data-mode', mode);
      root.setAttribute('data-' + mode, vid);

      mirrors().forEach(function (el) {
        el.setAttribute('data-mode', mode);
        el.setAttribute('data-' + mode, vid);
      });

      pushToForm(opt, notify);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-kop-opt]'), function (opt) {
      opt.addEventListener('click', function (evt) {
        if (window.getSelection && window.getSelection().type === 'Range') return;
        evt.preventDefault();
        apply(opt.getAttribute('data-kop-mode'), opt, true);
      });
      opt.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Enter' && evt.key !== ' ') return;
        evt.preventDefault();
        apply(opt.getAttribute('data-kop-mode'), opt, true);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-kop-head]'), function (head) {
      head.addEventListener('click', function (evt) {
        var mode = head.getAttribute('data-kop-head');
        if (root.getAttribute('data-mode') === mode) return;
        evt.preventDefault();
        apply(mode, selectedOption(mode), true);
      });
    });

    /* Boot: the markup already carries the right state, so only mirror it onto
       the form without firing a change the theme has not asked for. */
    var startMode = root.getAttribute('data-mode') || 'sub';
    var startOpt = selectedOption(startMode);
    if (startOpt) {
      var other = startMode === 'sub' ? 'otp' : 'sub';
      var otherOpt = selectedOption(other);
      mirrors().forEach(function (el) {
        el.setAttribute('data-mode', startMode);
        el.setAttribute('data-' + startMode, startOpt.getAttribute('data-variant-id') || '');
        if (otherOpt) {
          el.setAttribute('data-' + other, otherOpt.getAttribute('data-variant-id') || '');
        }
      });
      pushToForm(startOpt, false);
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kop-bb2]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
})();
